import PaginationTypes from './actionTypes'

function paginationReducer(state = {}, action) {
  switch (action.type) {
    case PaginationTypes.SELECT_PAGE:
    case PaginationTypes.INITIALIZE_PAGINATION:
      return Object.assign({}, state, {[action.name]: action.page})
  }

  return state
}

export default paginationReducer
